<ng-container *ngIf="platform?.status?.status === 'ok'">
    <app-platform-health-indicator label="Peticiones"
        helpText="Total de peticiones HTTP atendidas en el periodo, sumando todas las instancias del App Service.">
        {{ sumOf(platform?.series, 'Requests') | number:'1.0-0' }}
    </app-platform-health-indicator>

    <app-platform-health-indicator label="CPU máx. del plan"
        helpText="Pico de CPU del plan de App Service, agregado de todas sus instancias. Una media baja con picos al 100% suele indicar consultas pesadas puntuales, no falta de capacidad.">
        {{ maxOf(platform?.series, 'CpuPercentage') | number:'1.0-0' }}%
    </app-platform-health-indicator>

    <app-platform-health-indicator label="Instancias (rango)"
        helpText="Mínimo y máximo de instancias del App Service en el periodo. El escalado de este plan es por horario y no por métrica, así que un pico de carga fuera de ese horario no añade instancias. Azure no publica esta métrica para un slot de despliegue.">
        {{ minOf(platform?.series, 'InstanceCount') | number:'1.0-0' }}–{{ maxOf(platform?.series, 'InstanceCount') | number:'1.0-0' }}
    </app-platform-health-indicator>

    <app-platform-health-indicator label="Hilos máx."
        helpText="Pico de hilos del proceso. En Linux la cola de peticiones no es observable, porque HttpQueueLength es una métrica de IIS y siempre vale cero, así que el crecimiento de hilos es la mejor señal de que hay peticiones esperando.">
        {{ maxOf(platform?.series, 'Threads') | number:'1.0-0' }}
    </app-platform-health-indicator>

    <!-- comprobación explícita contra null (no *ngIf="fn() as x"): un pico de 0 peticiones/s o
         un 0% de 5xx son valores legítimos y "as" los trataría como falsy y los ocultaría -->
    <app-platform-health-indicator *ngIf="peakRequestsPerSecond() !== null" label="Pico peticiones/s"
        helpText="El intervalo con más tráfico del periodo, convertido a peticiones por segundo. Sirve para dimensionar: la media esconde los picos.">
        {{ peakRequestsPerSecond() | number:'1.1-1' }}
    </app-platform-health-indicator>

    <app-platform-health-indicator *ngIf="errorRatePercent() !== null" label="% de 5xx"
        helpText="Porcentaje de respuestas con error del servidor sobre el total del periodo. No incluye los 4xx, que son errores de la petición y no del servidor.">
        {{ errorRatePercent() | number:'1.1-2' }}%
    </app-platform-health-indicator>
</ng-container>

<!-- depende de Application Insights, no del bloque de plataforma: se enseña en cuanto ese bloque
     responda 'ok', aunque platform haya fallado -->
<app-platform-health-indicator *ngIf="worstP95Ms() !== null" label="Peor intervalo p95"
    helpText="El p95 más alto de todos los intervalos del periodo, según Application Insights. No es el p95 del periodo entero: los percentiles no se pueden promediar.">
    {{ worstP95Ms() | number:'1.0-0' }} ms
</app-platform-health-indicator>
